import { every, uniqBy } from 'lodash-es';
import { VisitExamination } from '../models';
import { SearchFormType } from '../search-page/search-page-type.enum';

export function getReportingPageFromExaminations(examinations: VisitExamination[]): SearchFormType | null {
    if (!examinations || examinations.length <= 0) {
        return null;
    }

    // Uno o più record.
    const numReported = examinations.filter((ex) => !!ex.idReport).length;

    // Tutti con idReport a null.
    if (numReported === 0) {
        // Se tutti hanno il flag IsEcg a true.
        if (every(examinations, (ex) => ex.isEcg)) {
            if (every(examinations, (ex) => !!ex.isExecuted || !!ex.reportingWithoutTrace)) {
                return SearchFormType.ECG;
            } else {
                return null;
            }
        }
        // Se almeno uno ha il flag IsEcg a false.
        // Se tutti idPatient sono guid.empty(isLocalPatient=true) (Fuori flusso).
        else if (every(examinations, (ex) => ex.patient.isLocalPatient)) {
            if (examinations.length > 1) {
                // La pagina non si apre se il numero di examination selezionate è > 1.
                return null;
            }

            return SearchFormType.VISIT;
        }
        // Qualcuno ha isLocalPatient=true e qualcuno isLocalPatient=false.
        const outOfFlowExaminations = examinations.filter((ex) => !ex.patient.isLocalPatient);
        const numOutOfFlowPatients = uniqBy(outOfFlowExaminations, (ex) => ex.patient.id).length;

        if (numOutOfFlowPatients === 1) {
            return SearchFormType.VISIT;
        }
        return null;
    } else if (numReported === examinations.length) {
        // Se tutti hanno idReport diverso da null.
        const numEcgReports = examinations.filter((ex) => !!ex.isEcgReport).length;
        if (numEcgReports === examinations.length) {
            // Se tutti hanno il flag isEcgReport a true.
            return SearchFormType.ECG;
        } else if (numEcgReports === 0) {
            // Se tutti hanno il flag isEcgReport a false.
            const distinctIdReport = uniqBy(examinations, (ex) => ex.idReport);
            if (distinctIdReport.length === 1) {
                // Apro il modulo visite se l'idReport è univoco.
                return SearchFormType.VISIT;
            }
            // Ci sono più idReport distinti
            return null;
        }
        return null;
    }

    // Non procedere se lo stato R non è omogeneo tra le prestazioni.
    return null;
}
